import React from 'react';
import { UserIntegrateTable } from './tables/UserIntegrateTable';
import { messageUtility } from '../utilities/messageUtility';
import { isPrimeRoleId, isTargetRoleId } from '../utilities/roleUtility';
import { USER_ROLES } from '../utilities/constants';

export class BlockUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sending: false,
    };
  }
  renderBlockUserMsg = () => {
    const { userRoleCode, isPrimary } = this.props.dialog;
    if (isPrimary) {
      if (isPrimeRoleId(userRoleCode)) {
        return 'アカウントを停止されたユーザーはBuildeeにログインできなくなります。よろしいですか？';
      }
      return (
        <React.Fragment>
          <span>
            アカウントを停止されたユーザーはBuildeeにログインできなくなります。
          </span>
          <br />
          <span>
            また、アクセスできた全ての現場でステータスが停止中に変更されます。
          </span>
          <br />
          <span>
            アカウントの復旧時、現場に再度アクセスするためには現場ごとにステータス変更が必要になる場合があります。
          </span>
          <br /> <br />
          <span>本当にアカウントを停止してよろしいですか？</span>
        </React.Fragment>
      );
    }
    return '使用停止されたユーザーはBuildeeにログインできなくなり、またすべての現場で使用できなくなります。よろしいですか？';
  };
  render() {
    const { userRoleCode } = this.props.dialog;
    return (
      <div
        className={`dialog-md dialog--modal ${
          isTargetRoleId([USER_ROLES.branch, USER_ROLES.manager], userRoleCode)
            ? 'dialog--wide'
            : ''
        }`}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>アカウントを停止する</span>
        </div>
        <div className='dialog-md__body text-left'>
          <p>{this.renderBlockUserMsg()}</p>
        </div>
        {this.state.sending ? (
          <div className='dialog-md__footer'>
            <div className='indicator' />
          </div>
        ) : (
          <div className='dialog-md__footer-horizontal'>
            <button
              id='modal-close-confirm-selected'
              className='btn-fixedsize--sub'
              onClick={() => {
                this.props.dialog.callback.cancel();
              }}
            >
              戻る
            </button>
            <button
              className='btn-fixedsize--negative'
              onClick={() => {
                this.setState({
                  sending: true,
                });
                this.props.dialog.callback.done();
              }}
            >
              停止する
            </button>
          </div>
        )}
      </div>
    );
  }
}

export class UnblockUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sending: false,
    };
  }

  renderUnblockUserMsg = () => {
    const { userRoleCode } = this.props.dialog;
    if (isTargetRoleId([USER_ROLES.branch, USER_ROLES.manager], userRoleCode)) {
      return (
        <React.Fragment>
          <span>
            アカウントを復旧されたユーザーはBuildeeにログイン可能になります。
          </span>
          <br />
          <span>
            また、以前アクセスできた現場のステータスは作業終了になっているため必要に応じて稼動中に変更してください。
          </span>
          <br /> <br />
          <span>アカウントを復旧してよろしいですか？</span>
        </React.Fragment>
      );
    }
    return 'アカウントを復旧されたユーザーはBuildeeにログイン可能になります。よろしいですか？';
  };

  render() {
    const { userRoleCode } = this.props.dialog;
    return (
      <div
        className={`dialog-md dialog--modal ${
          isTargetRoleId([USER_ROLES.branch, USER_ROLES.manager], userRoleCode)
            ? 'dialog--wide'
            : ''
        }`}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>アカウントを復旧する</span>
        </div>
        <div className='dialog-md__body text-left'>
          <p>{this.renderUnblockUserMsg()}</p>
        </div>
        <div className='dialog-md__footer-horizontal'>
          {this.state.sending ? (
            <div className='indicator' />
          ) : (
            <React.Fragment>
              <button
                id='modal-close-confirm-selected'
                className='btn-fixedsize--sub'
                onClick={() => {
                  this.props.dialog.callback.cancel();
                }}
              >
                戻る
              </button>
              <button
                className='btn-fixedsize--effective'
                onClick={() => {
                  this.setState({
                    sending: true,
                  });
                  this.props.dialog.callback.done();
                }}
              >
                復旧する
              </button>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export class BlockUnblockIntegratedUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sending: false,
    };
  }

  onSubmit = () => {
    this.setState({ sending: true });
    this.props.dialog.callback.done();
  };

  render() {
    const {
      doBlock,
      listUsersIntegrate,
      callback,
      allowSubmit,
    } = this.props.dialog;
    return (
      <div
        className='dialog-md dialog--modal BlockUnblockIntegratedUser'
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>
            {doBlock ? 'アカウントを停止する' : 'アカウントを復旧する'}
          </span>
        </div>
        <div className='dialog-md__body dialog-md__body-prewrap text-left'>
          <div className='dialog-md__body__description'>
            このアカウントは下記のアカウントと統合されています。
            <br />
            {doBlock
              ? 'このアカウントを停止すると、下記のアカウントも同時に停止され、Buildeeにログインできなくなります。\n' +
                'アカウントを停止してよろしいですか？'
              : 'このアカウントを復旧すると、下記のアカウントも同時に復旧され、Buildeeにログイン可能になります。\n' +
                'アカウントを復旧してよろしいですか？'}
          </div>
          <UserIntegrateTable data={listUsersIntegrate} maxHeightTable={351} />
        </div>
        <div className='dialog-md__footer-horizontal'>
          {this.state.sending ? (
            <div className='indicator' />
          ) : (
            <React.Fragment>
              <button
                id='modal-close-confirm-selected'
                className='btn-fixedsize--sub'
                onClick={() => {
                  callback.cancel();
                }}
              >
                戻る
              </button>
              {allowSubmit && (
                <button
                  className={`btn-fixedsize--${
                    doBlock ? 'negative' : 'effective'
                  }`}
                  onClick={this.onSubmit}
                >
                  {doBlock ? '停止する' : '復旧する'}
                </button>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export const BlockComplete = props => {
  return (
    <div
      className='dialog-md dialog--modal'
      onClick={event => {
        event.stopPropagation();
      }}
    >
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>アカウントを停止する</span>
      </div>
      <div className='dialog-md__body text-left'>
        <p>アカウントを停止しました。</p>
      </div>
      <div className='dialog-md__footer'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={() => {
            props.dialog.callback.cancel();
          }}
        >
          {messageUtility.getMessage('I-000-017')}
        </button>
      </div>
    </div>
  );
};

export const UnblockComplete = props => {
  return (
    <div
      className='dialog-md dialog--modal'
      onClick={event => {
        event.stopPropagation();
      }}
    >
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>アカウントを復旧する</span>
      </div>
      <div className='dialog-md__body text-left'>
        <p>アカウントを復旧しました。</p>
      </div>
      <div className='dialog-md__footer'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={() => {
            props.dialog.callback.cancel();
          }}
        >
          {messageUtility.getMessage('I-000-017')}
        </button>
      </div>
    </div>
  );
};

export const ErrorDialog = props => {
  return (
    <div
      className='dialog-md dialog--modal'
      onClick={event => {
        event.stopPropagation();
      }}
    >
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>
          {messageUtility.getMessage('E-001-402')}
        </span>
      </div>
      <div className='dialog-md__body text-left'>
        <p>{props.dialog.message}</p>
      </div>
      <div className='dialog-md__footer'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={() => {
            props.dialog.callback.cancel();
          }}
        >
          {messageUtility.getMessage('I-000-017')}
        </button>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/UserDialog.jsx